export default {
  computed: {
    shippingOrdersQuickFilters() {
      return {
        title: 'Shipping Orders',
        filters: {
          columns: [
            {
              class: 'col-12 col-md-2',
              filters: [
                {
                  name: 'status',
                  label: this.$gettext('Specific Statuses'),
                  type: 'checkbox-group',
                  options: [
                    {
                      text: this.$gettext('Confirmed'),
                      value: 'confirmed'
                    },
                    {
                      text: this.$gettext('Error'),
                      value: 'error'
                    },
                    {
                      text: this.$gettext('Canceled'),
                      value: 'canceled'
                    },
                    {
                      text: this.$gettext('Done'),
                      value: 'done'
                    }
                  ],
                  value: [],
                  stacked: true,
                  callback: (val) => {
                    if (val.length > 0) {
                      return [['status', 'in', val]]
                    } else {
                      return []
                    }
                  }
                },
                {
                  name: 'order-id',
                  label: this.$gettext('Order ID'),
                  type: 'text',
                  value: '',
                  callback: (val) => {
                    if (val.length > 0) {
                      return {
                        or: true,
                        filters: [
                          ['id', 'eq', val.trim()],
                          ['external_id', 'eq', val.trim()]
                        ]
                      }
                    } else {
                      return []
                    }
                  }
                }
              ]
            },
            {
              class: 'col-md-5',
              filters: [
                {
                  name: 'order-origin',
                  label: this.$gettext('Origin'),
                  type: 'geofence-autocomplete',
                  minCharacter: 3,
                  value: '',
                  callback: (val) => {
                    if (val.external_id) {
                      return [['origin_location', 'eq', val.external_id.trim()]]
                    } else {
                      return []
                    }
                  }
                },
                {
                  name: 'order-destination',
                  label: this.$gettext('Destination'),
                  type: 'geofence-autocomplete',
                  minCharacter: 3,
                  value: '',
                  callback: (val) => {
                    if (val.external_id) {
                      return [['destination_location', 'eq', val.external_id.trim()]]
                    } else {
                      return []
                    }
                  }
                },
                {
                  columns: [
                    {
                      class: 'col-12 col-md-6',
                      filters: [
                        {
                          name: 'commodity',
                          label: this.$gettext('Commodity'),
                          type: 'commodity-autocomplete',
                          minCharacter: 3,
                          value: '',
                          callback: (val) => {
                            if (val.id) {
                              return [['commodity_id', 'eq', val.id]]
                            } else {
                              return []
                            }
                          }
                        }
                      ]
                    },
                    {
                      class: 'col-12 col-md-6',
                      filters: [
                        {
                          name: 'equipment',
                          label: this.$gettext('Equipment Type'),
                          type: 'vehicle-type-autocomplete',
                          minCharacter: 3,
                          value: '',
                          remote: true,
                          callback: (val) => {
                            if (val.id) {
                              return [['vehicle_type_id', 'eq', val.id]]
                            } else {
                              return []
                            }
                          }
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              class: '',
              filters: [
                {
                  name: 'order-services',
                  label: this.$gettext('Order Services'),
                  type: 'order-service-autocomplete',
                  minCharacter: 3,
                  value: [],
                  callback: (val) => {
                    if (val.length > 0) {
                      const services = val.map(function (item) {
                        return item.id
                      })
                      return [['order_services.id', 'in', services]]
                    } else {
                      return []
                    }
                  }
                },
                {
                  name: 'order-delivery-date',
                  label: this.$gettext('Est. Delivery Date Range'),
                  type: 'daterange',
                  opens: 'left',
                  locale: {
                    format: this.$gettext('mm/dd/yyyy')
                  },
                  value: {
                    startDate: this.moment().toDate(),
                    endDate: this.moment().toDate(),
                    dateRangeActive: true
                  },
                  ranges: {
                    [this.$gettext('Today')]: [this.moment().toDate(), this.moment().toDate()],
                    [this.$gettext('Yesterday')]: [this.moment().subtract(1, 'days').toDate(), this.moment().subtract(1, 'days').toDate()],
                    [this.$gettext('Last 7 days')]: [this.moment().subtract(6, 'day').toDate(), this.moment().toDate()],
                    [this.$gettext('Tomorrow')]: [this.moment().add(1, 'days').toDate(), this.moment().add(1, 'days').toDate()],
                    [this.$gettext('Next 7 days')]: [this.moment().toDate(), this.moment().add(6, 'days').toDate()]
                  },
                  callback: (val, filtersState) => {
                    console.log('FILTERS STATE*********', filtersState)

                    if (!filtersState['order-id'] && val.dateRangeActive) {
                      const range = [
                        this.moment.tz(val.startDate, this.$tz).startOf('day').utc().format('YYYY-MM-DD HH:mm:ss'),
                        this.moment.tz(val.endDate, this.$tz).endOf('day').utc().format('YYYY-MM-DD HH:mm:ss')
                      ]
                      return [['delivery_date', 'bt', range]]
                    } else {
                      return []
                    }
                  }
                }
              ]
            }
          ]
        }
      }
    }
  }
}
